<div class="container-fluid">
	<div class="row">

	<!-- LEFT HAND SIDE NAVIGATION (Also where the Rule Name/Group can be set) -->
	<div class="col-sm-3">
		<app-rule-editor-lhs-nav
			[mRule]="this.mRule"
			[mStep]="this.mStep"
			(stepSelected)="this.selectStep($event)"
			> 
		</app-rule-editor-lhs-nav>
	</div>	
	
	<!-- RIGHT HAND SIDE - STEP DISPLAYS -->
	<div class="col-sm-9" style="padding-bottom: 50px">
	
		<!-- STEP 1 - SELECT THE TRIGGER -->
		<app-rule-editor-step-select-trigger
			[mRule]="this.mRule"
			>
		</app-rule-editor-step-select-trigger>
		
		<!--STEP 2 - SETUP PARAMETERS -->
		<app-rule-editor-step-setup-parameters
			[mRule]="this.mRule"
			>
		</app-rule-editor-step-setup-parameters>
		
		<!-- STEP 3 - ADD FILTER(S) -->
		<app-rule-editor-step-add-filters
			[mRule]="this.mRule"
			>
		</app-rule-editor-step-add-filters>
		
		<!-- STEP 4 - CHOOSE REACTION(S) -->
		<app-rule-editor-step-choose-reactions
			[mRule]="this.mRule"
			>
		</app-rule-editor-step-choose-reactions>
		
		<!-- STEP 5 - REVIEW & FINISH -->
		<app-rule-editor-step-review-and-finish
			[mRule]="this.mRule"
			>
		</app-rule-editor-step-review-and-finish>
		
	</div>
	</div>
</div>

<!-- Simple Success Error Dialog Box - Displaying the Error generated for now since we dont display success msgs -->
<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>